import axios from 'axios';
/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 21/03/18
 */
import {
  PAYMENT_METHODS,
  PAYMENT_METHOD_REGISTRATIONS,
  PAYMENT_METHOD_BULK_REGISTRATIONS,
  PAYMENT_METHOD_REGISTRATION_STATUS,
  PAYMENT_METHOD_ACTIVATE_PAYMENT_METHOD,
  PAYMENT_METHOD_KYB_STATUS,
  PAYMENT_METHOD_OUTLET_BANK_STATUS,
} from './constant';

export function getAllPaymentMethods() {
  return axios.get(PAYMENT_METHODS);
}

export function postNewPaymentMethods(data) {
  return axios.post(PAYMENT_METHOD_REGISTRATIONS, data);
}

export function postNewBulkRegistrationPaymentMethods(data) {
  return axios.post(PAYMENT_METHOD_BULK_REGISTRATIONS, data);
}

export function checkWalletRegistration(data) {
  return axios.post(PAYMENT_METHOD_REGISTRATION_STATUS, data);
}

export function checkKybStatus() {
  return axios.get(`${PAYMENT_METHOD_KYB_STATUS}/kyb-status`);
}

export function checkOutletBankStatus() {
  return axios.get(`${PAYMENT_METHOD_OUTLET_BANK_STATUS}`, {
    withCredentials: true,
  });
}

export function activateAllPaymentMethod(data) {
  return axios.post(PAYMENT_METHOD_ACTIVATE_PAYMENT_METHOD, data);
}
